import FAQBanner from "../components/FAQ/faqBanner";
import FAQSection from "../components/FAQ/faqSection";

const Faq = () =>{
    return(
        <>
        <FAQBanner/>
        <FAQSection/>

        </>
    )
}

export default Faq;